(function () {
  'use strict';

  function init(container) {
    var blocks = container.querySelectorAll('[data-wbst-block]');
    if (!blocks.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    blocks.forEach(function (block) {
      initBlock(block, prefersReduced);
    });
  }

  function initBlock(block, prefersReduced) {
    var track = block.querySelector('[data-wbst-track]');
    var dots = block.querySelectorAll('[data-wbst-dot]');
    var items = block.querySelectorAll('[data-wbst-item]');
    var videos = block.querySelectorAll('.wb-steps__video');

    videos.forEach(function (video) {
      var playAttempt = video.play();

      if (playAttempt !== undefined) {
        playAttempt.catch(function () {});
      }
    });

    if (!track || !dots.length || !items.length) return;
    if (block.classList.contains('wb-steps--mob-grid')) return;

    var currentDot = 0;
    var rafId = null;

    function updateDots(index) {
      dots.forEach(function (dot) {
        dot.classList.remove('is-active');
      });

      if (dots[index]) {
        dots[index].classList.add('is-active');
      }

      currentDot = index;
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-wbst-dot'), 10);
        var item = items[index];

        if (!item) return;

        track.scrollTo({
          left: item.offsetLeft,
          behavior: prefersReduced ? 'auto' : 'smooth'
        });

        updateDots(index);
      });
    });

    track.addEventListener('scroll', function () {
      if (rafId) return;

      rafId = requestAnimationFrame(function () {
        rafId = null;

        var trackLeft = track.getBoundingClientRect().left;
        var closest = 0;
        var minDist = Infinity;

        items.forEach(function (item, index) {
          var dist = Math.abs(item.getBoundingClientRect().left - trackLeft);

          if (dist < minDist) {
            minDist = dist;
            closest = index;
          }
        });

        if (closest !== currentDot) {
          updateDots(closest);
        }
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();